import Partners from '@/views/partners/Partners'
import PartnerRules from '@/views/partners/PartnerRules.vue'
import SponsorPartner from '@/views/partners/SponsorPartner.vue'
import SponsorPartnerRules from '@/views/partners/SponsorPartnerRules.vue'
import getWhiteLabel from '@/utils/getWhiteLabel'

import Index from '@/views/Index.vue';

const partnersRouter = {
    path: '/partners',
    component: Index,
    name: 'partners',
    meta: {
        requiresAuth: true
    },
    children: [{
            name: 'client/partners',
            path: '/',
            component: Partners,
            meta: {
                title: `${getWhiteLabel()} - Parceiros`,
                requiresAuth: true
            },
        },
        {
            name: 'client/partners',
            path: 'new',
            component: PartnerRules,
            meta: {
                title: `${getWhiteLabel()} - Novo parceiro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/partners',
            path: ':partnerId/update',
            component: PartnerRules,
            meta: {
                title: `${getWhiteLabel()} - Novo parceiro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/partners',
            path: 'new/:partnerId/sponsor',
            component: SponsorPartner,
            meta: {
                title: `${getWhiteLabel()} - Financiadores do parceiros`,
                requiresAuth: true
            },
        },
        {
            name: 'client/partners',
            path: 'new/:partnerId/sponsor/:cnpjId/rules',
            component: SponsorPartnerRules,
            meta: {
                title: `${getWhiteLabel()} - Parceiros`,
                requiresAuth: true
            },
        },
        {
            name: 'client/partners',
            path: ':partnerId/sponsor/:cnpjId/rules',
            component: SponsorPartnerRules,
            meta: {
                title: `${getWhiteLabel()} - Parceiros`,
                requiresAuth: true
            },
        },
        {
            name: 'client/partners',
            path: ':partnerId/sponsor/:cnpjId/secondary/rules',
            component: SponsorPartnerRules,
            meta: {
                title: `${getWhiteLabel()} - Parceiros`,
                requiresAuth: true
            },
        },
        {
            name: 'client/partners',
            path: ':partnerId/edit',
            component: PartnerRules,
            meta: {
                title: `${getWhiteLabel()} - Parceiros`,
                requiresAuth: true
            },
        },
        {
            name: 'client/partners',
            path: ':partnerId/sponsors',
            component: SponsorPartner,
            meta: {
                title: `${getWhiteLabel()} - Parceiros`,
                requiresAuth: true
            },
        },
    ]

}

export default partnersRouter;